const prefix = 'selectable-accordion';

export const dataHooks = {
  item: `${prefix}-item`,
  itemHeader: `${prefix}-item-header`,
};

export const TYPES = {
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  TOGGLE: 'toggle',
};

export const dataAttr = {
  STATE: 'data-state',
  DISABLED: 'data-disabled',
};

export const VERTICAL_PADDING = {
  medium: 'medium',
  small: 'small',
  tiny: 'tiny',
};
